import script from "./waveCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./waveCanvas.vue?vue&type=script&setup=true&lang=ts"

import "./waveCanvas.vue?vue&type=style&index=0&id=3733eeb3&lang=scss&scoped=true"
import "./waveCanvas.vue?vue&type=style&index=1&id=3733eeb3&scoped=true&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3733eeb3"]])

export default __exports__